module.exports = __webpack_public_path__ + "img/ercode_h.38b98dd1.png";